import { Button, Icon, Text, Spinner2 } from 'components';
import { Api, theme, titleToLocaleKey } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentSuccess = () => {
  const { t } = useTranslation(),
    navigate = useNavigate(),
    [searchParams] = useSearchParams(),
    { isMobile } = useSelector((state) => state.appState);

  const teamId = searchParams.get('teamId');

  const [loading] = useState(false);
  const rawTitle = searchParams.get('title') || 'Premium';
  const [subscriptionData] = useState({
    tier: t(`subscription.plans.${titleToLocaleKey(rawTitle)}`, { defaultValue: rawTitle }),
    teamName: searchParams.get('teamName') || 'Team',
    status: t('subscription.processing')
  });

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-100px)] bg-[#F8F9FA]">
        <Spinner2 col={theme.SECONDARY} />
      </div>
    );
  }

  if (!subscriptionData) {
    return (
      <div className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-100px)] bg-[#F8F9FA] p-5">
        <Text h4 center col={theme.GREY_50}>
          {t('subscription.fetchInfoError')}
        </Text>
        <Button text={t('common.goHome')} onClick={() => navigate('/')} style={{ marginTop: 20 }} />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-100px)] bg-gray-50 p-5">
      <div
        className={`flex flex-col items-center justify-center w-full max-w-[480px] ${isMobile ? 'p-6' : 'p-10'} bg-white rounded-[24px] shadow-[0_10px_30px_rgba(0,0,0,0.05)] border border-gray-100 animate-in fade-in slide-in-from-bottom-5 duration-700`}
      >
        <div className="flex flex-col items-center justify-center mb-10 w-full">
          <div
            style={{
              background: theme.GREEN,
              width: 80,
              height: 80,
              borderRadius: 40,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 16,
              boxShadow: `0 8px 16px ${theme.GREEN}40`
            }}
          >
            <Icon type="check" dimensions={40} col="#fff" />
          </div>
          <Text h3={isMobile} h2={!isMobile} center>
            {t('subscription.paymentProcessing')}
          </Text>
          <Text b2 col={theme.GREY_50} marg="8px 0 0" center size={isMobile ? '13px' : '14px'}>
            {t('subscription.processingMessage')}
          </Text>
        </div>

        <div className="w-full mb-10 space-y-1">
          <div className="flex items-center justify-between w-full py-4 border-b border-[#F0F2F4]">
            <Text b1 bold marg="0">
              {t('subscription.planTier')}
            </Text>
            <div className="px-4 py-1.5 rounded-full text-white font-bold text-xs uppercase tracking-wider shadow-sm bg-slate-900 shadow-slate-900/10">
              {subscriptionData.tier}
            </div>
          </div>

          <div className="flex items-center justify-between w-full py-4 border-b border-[#F0F2F4]">
            <Text b1 bold marg="0">
              {t('subscription.team')}
            </Text>
            <Text b1={!isMobile} b2={isMobile} col={theme.GREY_60} bold marg="0">
              {subscriptionData.teamName.trim()}
            </Text>
          </div>

          <div className="flex items-center justify-between w-full py-4 border-b border-[#F0F2F4]">
            <Text b1={!isMobile} b2={isMobile} bold marg="0">
              {t('subscription.status')}
            </Text>
            <Text b1={!isMobile} b2={isMobile} col={theme.GREEN} bold marg="0">
              {subscriptionData.status}
            </Text>
          </div>
        </div>

        <div className="w-full space-y-4">
          <Button
            text={t('subscription.manageSubscription')}
            onClick={() => {
              navigate('/billing?tab=1');
            }}
            wid="100%"
            big
          />

          <Button
            text={t('common.continue')}
            onClick={async () => {
              if (teamId) {
                const res = await Api.post('/users/get', { userId: teamId });
                if (res?.user?.username) {
                  navigate(`/profile/${res.user.username}`, { replace: true });
                  return;
                }
              }
              window.history.go(-4);
            }}
            wid="100%"
            bordered
            big
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
